import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { getQeConfigListByGroupId, getAllQeDashConfig } from "@/api/qe_dash_config";
import infoList from "@/components/mixins/infoList";
import { addGroupQE } from "@/api/sys_group";
export default {
  name: "Forms",
  mixins: [infoList],
  data: function data() {
    return {
      formTransferData: [],
      formTransferModel: []
    };
  },
  props: {
    row: {
      default: function _default() {
        return {};
      }
      // type: Object
    }
  },
  methods: {
    SaveForms: function () {
      var _SaveForms = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var configIds, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              configIds = [];
              this.formTransferModel && this.formTransferModel.map(function (item) {
                configIds.push(item);
              });
              _context.next = 1;
              return addGroupQE({
                QeIds: configIds,
                GroupId: this.row.ID
              });
            case 1:
              res = _context.sent;
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "config success!"
                });
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function SaveForms() {
        return _SaveForms.apply(this, arguments);
      }
      return SaveForms;
    }(),
    filterMethod: function filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    LoadLeftReport: function () {
      var _LoadLeftReport = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getAllQeDashConfig();
            case 1:
              res = _context2.sent;
              if (res.data) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              this.formTransferData = res.data.map(function (qe) {
                return {
                  key: qe.ID,
                  label: qe.name
                };
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function LoadLeftReport() {
        return _LoadLeftReport.apply(this, arguments);
      }
      return LoadLeftReport;
    }(),
    LoadRightReport: function () {
      var _LoadRightReport = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this = this;
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getQeConfigListByGroupId({
                GroupId: this.row.ID
              });
            case 1:
              res = _context3.sent;
              if (res.data) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              res.data.map(function (item) {
                _this.formTransferModel.push(item.ID);
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function LoadRightReport() {
        return _LoadRightReport.apply(this, arguments);
      }
      return LoadRightReport;
    }()
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 1;
            return this.LoadLeftReport();
          case 1:
            _context4.next = 2;
            return this.LoadRightReport();
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }()
};